import { StyledIconButton } from './styles';
import { CustomIconButtonProps } from './types';

const IconButton = ({ children, ...rest }: CustomIconButtonProps) => {
  return <StyledIconButton {...rest}>{children}</StyledIconButton>;
};

export default IconButton;
